<template>
  <div class="dropdown d-inline ">
    <soft-button v-show="statusSelected == ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class="dropdown-toggle ms-2"
      data-bs-toggle="dropdown" aria-expanded="true">{{btnTitle}}</soft-button>
    <soft-button v-show="statusSelected != ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class='dropdown-toggle ms-2 active-filter' 
      data-bs-toggle="dropdown" aria-expanded="false">{{btnTitle}}</soft-button>

    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="navbarDropdownMenuLink2">
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='from_sga_queue'? 'active':'']" type="button" @click="handleClick('from_sga_queue')">Cola desde SGA </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='to_sga_queue'? 'active':'']" type="button" @click="handleClick('to_sga_queue')">Cola a SGA </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='to_sga_queue_orders'? 'active':'']" type="button" @click="handleClick('to_sga_queue_orders')">Cola de compras a SGA </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='to_sga_queue_orders_back'? 'active':'']" type="button" @click="handleClick('to_sga_queue_orders_back')">Cola de devoluciones a SGA </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='to_sga_queue_products'? 'active':'']" type="button" @click="handleClick('to_sga_queue_products')">Cola de productos a SGA </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='to_sga_queue_purchases'? 'active':'']" type="button" @click="handleClick('to_sga_queue_purchases')">Cola de compras a SGA </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='to_odoo_queue'? 'active':'']" type="button" @click="handleClick('to_odoo_queue')">Cola A ODOO</button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='to_webhook_queue'? 'active':'']" type="button" @click="handleClick('to_webhook_queue')">Cola A Webhook</button>
      </li>
    </ul>   
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";

export default {
  name:"QueuesFilter",
  components: {
    SoftButton,  
  },
  props: {
    filterStatusSelected: {
      type: String,
      required: true
    },
  },
  emits: ['filter-change', 'input'],
  data() {
    return {
    statusSelected:""
    }
  },
  computed: {
    btnTitle() {
      let title='';
      switch (this.filterStatusSelected) {
      case "from_sga_queue":
        title = 'Cola desde SGA';
        break;
      case "to_sga_queue":
        title='Cola a SGA';
        break;
      case "to_sga_queue_orders":
        title='Cola de compras a SGA';
        break;
      case "to_sga_queue_orders_back":
        title='Cola de devoluciones a SGA';
        break;
      case "to_sga_queue_products":
        title='Cola de productos a SGA';
        break;
      case "to_sga_queue_purchases":
        title='Cola de compras a SGA';
        break;
      case "to_odoo_queue":
        title='Cola A ODOO';
        break;
      case "to_webhook_queue":
        title='Cola A Webhook';
        break;
      default:
        'Cola desde SGA'
      }
      return title;
    }
  },
  watch: {
    filterStatusSelected(newValue) {
      this.statusSelected = newValue
    },
    statusSelected(newValue){
      this.$emit("input", newValue);
    }
  },
  mounted () {
    this.statusSelected= this.filterStatusSelected;
  },
  methods: {
    handleClick(status) {
      this.statusSelected=status
      this.$emit('filter-change',status)
    },
  },
}
</script>

<style scoped>
.active{
  background-color: rgb(234, 244, 247) !important;
}

.active-filter {
  color: #fff;
  background-color: #344767;
  border-color: #344767;
}
</style>